import React from "react";
import Navbar from "./components/Navbar";
import HomePage from "./components/Home";
import Footer from "./components/Footer";
// import Careers from "./components/Careers";
import { Helmet } from "react-helmet";

function App() {
  return (
    <div className="mt-0">
      <Helmet>
        <meta name="description" content="Madura Mercerisers" />
        <meta
          name="keywords"
          content="Madura Mercerisers, Madura, mercerising, compacting, stentering, biowashing, special finishes, tirupur, garment manufacturing, readymade fabrics, printing, knitted fabric and garment solutions, GOTS Certified "
        />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.maduramercerisers.com/" />
        <meta property="og:title" content="Madura Mercerisers" />
        <meta
          property="og:description"
          content="Knitted Fabrics and Garment excellence"
        />
        <meta
          property="og:image"
          content="https://www.maduramercerisers.com/MaduraLogo.ico"
        />

        {/* Twitter */}
        <meta property="twitter:card" content="Madura Mercerisers" />
        <meta
          property="twitter:url"
          content="https://www.maduramercerisers.com/"
        />
        <meta property="twitter:title" content="Madura Mercerisers" />
        <meta
          property="twitter:description"
          content="Knitted Fabrics and Garment excellence"
        />
        <meta
          property="twitter:image"
          content="https://www.maduramercerisers.com/MaduraLogo.ico"
        />
        <title>Madura Mercerisers</title>
        {/* Other common meta tags */}
      </Helmet>
      <div className="">
        <Navbar />
        {/* Home page start */}
        <HomePage></HomePage>
        {/* Home page end */}
        <Footer></Footer>
      </div>
    </div>
  );
}

export default App;
